import { createIcon } from '../shared'

const MusicIcon = createIcon(
  ({ color }) => (
    <path
      d="M23.3331 7.17343C23.3335 7.07316 23.3114 6.97409 23.2682 6.88359C23.2251 6.79308 23.1621 6.71347 23.0839 6.65068C23.0058 6.58789 22.9144 6.54354 22.8168 6.52093C22.7191 6.49832 22.6176 6.49803 22.5198 6.52009L11.8598 8.94676C11.7127 8.97991 11.5813 9.06189 11.4869 9.17933C11.3924 9.29676 11.3406 9.44273 11.3398 9.59343V25.3334C11.3598 26.7801 9.87309 28.2868 7.73975 28.8534C5.36642 29.4934 3.09975 28.7201 2.67309 27.1401C2.25309 25.5601 3.83309 23.7601 6.20642 23.1268C7.00881 22.9043 7.84807 22.8476 8.67309 22.9601V9.59343C8.67422 8.83766 8.93215 8.10472 9.40456 7.51481C9.87698 6.92489 10.5358 6.51303 11.2731 6.34676L21.9264 3.92009C22.4148 3.8089 22.922 3.80919 23.4102 3.92096C23.8985 4.03273 24.3553 4.2531 24.7467 4.56569C25.138 4.87828 25.4539 5.27505 25.6709 5.72652C25.8878 6.17798 26.0002 6.67254 25.9998 7.17343V22.0801C26.0531 23.5468 24.5531 25.0801 22.3998 25.6534C20.0264 26.2868 17.7598 25.5201 17.3331 23.9401C16.9131 22.3534 18.4931 20.5534 20.8664 19.9201C21.6688 19.6977 22.5081 19.641 23.3331 19.7534V7.17343Z"
      fill={color}
    />
  ),
  '0 0 32 32',
  'MusicIcon',
)

export { MusicIcon }
